import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import PhonePerformanceMetricsColumns from '../common-columns/phone-performance-metrics-columns';
import SOVColumns from '../common-columns/sov-columns';
import SOVLostColumns from '../common-columns/sov-lost-columns';
import AudienceSOVColumns from '../common-columns/audience-sov-columns';
import QualityScoreColumns from '../common-columns/quality-score-columns';

export function getColumnsMetadata() {
  return _.defaults(
    {
      AdGroup: 'Name',
      Campaign: 'Campaign/Name',
      Delivery: 'DeliveryStatus',
      BidStrategyName: 'Campaign/BidStrategyName',
      BidStrategyType: 'DisplayBiddingStrategyType',
      AdGroupId: 'Id',
      TrackingTemplate: 'TrackingUrlTemplate',
      CustomParameters: 'UrlCustomParameters',
      CallForwarding: 'CallTrackingStatus',
      Language: 'Language',
      CashbackScope: 'AdGroupCashback/Scope',
      CashbackPercent: 'AdGroupCashback/Percent',
      Coupon: 'AdGroupCashback/CouponsEnabled',
    },
    PerformanceMetricsColumns,
    PhonePerformanceMetricsColumns,
    SOVColumns,
    SOVLostColumns,
    QualityScoreColumns,
    AudienceSOVColumns
  );
}
